module.exports = __webpack_public_path__ + "static/media/kews_graphic.5ef8fee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/contact/kews_graphic.png
// module id = 333
// module chunks = 0